// extracted by mini-css-extract-plugin
module.exports = {"sider":"Sidebar_sider__1fC6l","menu":"Sidebar_menu__1pOUX","logo":"Sidebar_logo__hBcdh"};